import styled from 'styled-components';
import backdrop from '../assets/images/backdrop.png';
import withProps from '../utils/withProps';

const Triangles = withProps({ src: backdrop })(
  styled.img`
    position: absolute;
    object-fit: contain;
    width: 32%;
    opacity: 0.5;
  `
);

export const TrianglesTopLeft = styled(Triangles)`
  left: 0;
  top: 0;
`;

export const TrianglesBottomLeft = styled(Triangles)`
  left: 0;
  bottom: 0;
  transform: rotate(-90deg);
`;

export const TrianglesTopRight = styled(Triangles)`
  right: 0;
  top: 0;
  transform: rotate(90deg);
`;

export const TrianglesBottomRight = styled(Triangles)`
  right: 0;
  bottom: 0;
  transform: rotate(180deg);
`;
